/**
 * Limits Questionnaire Popup View
 */

define(function(require, exports, module) {
    'user strict';

    var _ = require('underscore');
    var i18n = require('i18n');
    var $ = require('j');
    var Form = require('class/form.class');
    var user = require('user');
    var config = require('config');
    var server = require('server');
    var core = require('core');
    var BaseReplacerView = require('common/base.replacer.view');
    var depositLimitsConfig = require('modules/deposit-limits-config/deposit.limits.config.instance');
    var userValidationConfig = require('modules/user/user.validation.config');

    module.exports = BaseReplacerView.extend({

        initialize: function(options) {
            this.options = JSON.parse(options.params.join(','));
        },

        events: {
            'change .fn-remove-actual-limits': 'handleToggleUnlimited',
            'tap .fn-confirm': 'handleConfirm'
        },

        savedLimitsValues: {},

        subscribe: function() {
            this.listenTo(core, 'auth:logout', this.closeAsync);
        },

        getQuestionnaireMarkup: function(data) {
            return this.tmpl('limits.spanish.questionnaire', data);
        },

        render: function() {
            var wcId = config.get('questionnaireWebContent');

            if (wcId) {
                this.loadContent(wcId).done(this.renderContent.bind(this));
            } else {
                this.renderContent();
            }

            return this;
        },

        renderContent: function(html) {
            this.$el.html(this.getQuestionnaireMarkup(this.formatTemplateData(html)));

            this.form = new Form(this.$('.fn-limits-questionnaire-form'), {
                validationConfig: this.getValidationConfig(),
                data: this.getFormData()
            });
        },

        getValidationConfig: function() {
            var data = this.options.limitsData;
            var cfg = data.depositConfig;

            return _.extend(userValidationConfig(), {
                limitsQuestion: {
                    required: true
                },
                depositLimit: {
                    regexp: {
                        regexp: /^[0-9]+$/,
                        message: i18n.t('playtech.mobile.system.user.tooltip.limit.regexp')
                    },
                    fn: {
                        fn: function($inputs) {
                            // check value not lower than the increased value on deposit limit page
                            var val = Number($inputs.val());
                            var unlimited = Number(cfg.UNLIMITED_AMOUNT);
                            var name = $inputs[0].name;
                            var allowedLimits = data.allowedLimits.map(Number);
                            var isDisabledType = cfg.predefinedType === 'disabled';
                            var isEnabledType = cfg.predefinedType === 'enabled';
                            var isNoLimitsAllowed = cfg.noLimitsAllowed;

                            if (cfg.noLimitsAllowed) {
                                allowedLimits.pop();
                            }
                            var allowedAmount = Number(data[name]);
                            var isEmptyAllowed = allowedAmount === 0 && (!cfg.playerMustSetLimits ||
                                cfg.playerMustSetLimits && !cfg.allPeriodsRequired);
                            var min = allowedAmount === 0 && !isDisabledType
                                ? Math.min.apply(null, allowedLimits)
                                : allowedAmount;
                            var max = Math.max.apply(null, allowedLimits);

                            // if allowed only 'Unlimited' value
                            if (allowedAmount === unlimited && val !== allowedAmount) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.onlyUnlimited');
                                return false;
                            }
                            if (isDisabledType) {
                                if (val > 0 && val < min || val === 0 && !isEmptyAllowed) {
                                    var tkDisabled = 'playtech.mobile.system.tooltip.disabledType' + (isEmptyAllowed
                                        ? '.empty'
                                        : '');
                                    this.message = i18n.t(tkDisabled, min);
                                    return false;
                                }
                            }
                            if (isEnabledType) {
                                if (val > 0 && (val < min || val > max && val !== unlimited || val === 0
                                    && !isEmptyAllowed)) {
                                    var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (isEmptyAllowed
                                        ? '.empty'
                                        : '');
                                    var isOnlyLastLimit = allowedLimits.indexOf(allowedAmount) === allowedLimits.length
                                        - 1;
                                    if (isOnlyLastLimit) {
                                        var tkEnabledLast = 'playtech.mobile.system.tooltip.limits.enabledType.lastAmount'
                                            + (isNoLimitsAllowed ? '.unlimited' : '');
                                        this.message = i18n.t(tkEnabledLast, allowedAmount);
                                        return false;
                                    }
                                    this.message = i18n.t(tkEnabled, min, max);
                                    return false;
                                }
                            }

                            return userValidationConfig().depositLimit.fn.fn.apply(this, arguments);
                        }
                    }
                }
            });
        },

        formatTemplateData: function(topHtml) {
            var data = this.options.limitsData;
            var allowedLimits = data.fetchedDepositLimits.allowedLimits || data.allowedLimits;

            return _.extend(data, {
                dailyDepositLimits: this.removeSmallerLimits(allowedLimits, data.daydepositlimit),
                weeklyDepositLimits: this.removeSmallerLimits(allowedLimits, data.weekdepositlimit),
                monthlyDepositLimits: this.removeSmallerLimits(allowedLimits, data.monthdepositlimit),
                topContent: topHtml || ''
            });
        },

        removeSmallerLimits: function(limits, currentLimit) {
            return limits.filter(function(limit) {
                return parseInt(limit) >= currentLimit;
            });
        },

        handleToggleUnlimited: function(e) {
            var $limitList = this.$('.fn-day-deposit-limit, .fn-week-deposit-limit, .fn-month-deposit-limit');
            var checked = e.currentTarget.checked;
            checked ? this.setUnlimitedLimits($limitList) : this.unsetUnlimitedLimits($limitList);
        },

        setUnlimitedLimits: function($limitList) {
            $limitList.forEach(function(el) {
                var $inputField = $(el).find('input[type=hidden]');
                var limitType = el.dataset.depositLimitType;
                var currentValue = $inputField.val();

                this.savedLimitsValues[limitType] = {
                    name: limitType,
                    savedValue: currentValue
                };
                this.form.resetField($(el));

                $(el).trigger(new $.Event('change:options', {
                    payload: {
                        value: depositLimitsConfig.UNLIMITED_AMOUNT,
                        disabled: true
                    }
                }));
            }.bind(this));
        },

        unsetUnlimitedLimits: function($limitList) {
            $limitList.forEach(function(el) {
                var limitType = el.dataset.depositLimitType;
                var currentValue = this.savedLimitsValues[limitType].savedValue;

                $(el).trigger(new $.Event('change:options', {
                    payload: {
                        value: currentValue,
                        disabled: false
                    }
                }));
            }.bind(this));
        },

        handleConfirm: function() {
            this.form.validate()
                .done(function(data, form) {
                    form.showLoading();
                    this.subscribeOnInbox();
                }.bind(this))
                .fail(function() {
                    // hack for correct validate form
                    this.form.$el.removeClass('form-questionnaire-no-validation');
                }.bind(this));

        },

        submitResponses: function() {
            var mailTemplateData = this.getMailTemplateData();

            this.sendMail($(this.tmpl('limits.spanish.questionnaire.mail', mailTemplateData)).html())
                .always(function() {
                    this.form.hideLoading();
                }.bind(this));
        },

        getMailTemplateData: function() {
            var questionnaireData = Object.assign({}, this.getFormData(), this.form.selectedData);
            var userDetails = user.get('userDetails');

            questionnaireData.firstName = userDetails.firstName;
            questionnaireData.lastName = userDetails.lastName;
            questionnaireData.fullFirstName = userDetails.fullFirstname;
            questionnaireData.fullFirstSurname = userDetails.fullFirstSurname;
            questionnaireData.fullSecondSurname = userDetails.fullSecondSurname;
            questionnaireData.email = userDetails.email;
            questionnaireData.currencyCode = userDetails.currency;
            questionnaireData.UNLIMITED_AMOUNT = depositLimitsConfig.UNLIMITED_AMOUNT;

            return questionnaireData;
        },

        getFormData: function() {
            var data = this.options.limitsData;
            var cfg = data.depositConfig;

            return {
                allowedLimits: data.allowedLimits,
                predefinedType: cfg.predefinedType,
                playerMustSetLimits: cfg.playerMustSetLimits,
                allPeriodsRequired: cfg.allPeriodsRequired,
                noLimitsAllowed: cfg.noLimitsAllowed,
                UNLIMITED_AMOUNT: cfg.UNLIMITED_AMOUNT,
                type: 'questionnaire'
            };
        },

        subscribeOnInbox: function() {
            return server
                .send({
                    ID: 70001,
                    description: 'Subscribe on Inbox',
                    responses: [70002]
                })
                .then(function(response) {
                    var data = response.data;
                    var status = data && data.status || {};

                    return status.code === 'OK'
                        ? this.submitResponses()
                        : this.showMessageInboxSubscribe();
                }.bind(this))
                .fail(this.showMessageInboxSubscribe.bind(this));
        },

        sendMail: function(message) {
            const typeMap = {
                daydepositlimit: 'daily',
                weekdepositlimit: 'weekly',
                monthdepositlimit: 'monthly'
            };
            const formData = {};
            const subject = 'Questionnaire details for ' + user.get('username') + ' at '
                + window.Playtech.API.formatter.getDateTimeShort(Date.now());
            const request = server.send({
                ID: 70003,
                description: 'Inbox OAPI send message to support',
                responses: [70004],
                subject: subject,
                category: 'SUPPORT',
                subcategory: 'ACCOUNT',
                body: message
            });

            this.form._customControls.forEach((control) => {
                const id = control.$value.attr('id');

                if (id in typeMap) {
                    formData[id] = control.$value.val();
                }
            });

            return request
                .done(data => {
                    this.updateDepositLimits(formData)
                        .done(() => {
                            this.sendMessageSuccess(data);
                            core.trigger('page:refresh');
                        })
                        .fail(response => this.errorUpdateLimits(response));
                })
                .fail(() => this.sendMessageFail());
        },

        updateDepositLimits: function(data) {
            return server.send({
                ID: 89904,
                description: 'Set Player Deposit Limits',
                correlationId: 'update-deposit-limit',
                responses: [89908, 89900],
                limits: this.getDepositLimitsPeriodData(data)
            });
        },

        getDepositLimitsPeriodData: function(data) {
            const limits = [];
            const typeMap = {
                daydepositlimit: 'daily',
                weekdepositlimit: 'weekly',
                monthdepositlimit: 'monthly'
            };
            const defaultTypeMap = {
                daydepositlimit: 'casinodefaultdepositlimitday',
                weekdepositlimit: 'casinodefaultdepositlimitweek',
                monthdepositlimit: 'casinodefaultdepositlimitmonth'
            };
            const { currentLimits } = this.options.limitsData.fetchedDepositLimits;

            for (const key in data) {
                const amount = data[key];
                const timePeriod = typeMap[key];
                const currentLimit = currentLimits.find(obj => obj.timePeriod === timePeriod);
                const defaultLimit = this.options.limitsData[defaultTypeMap[key]].toString() || '0';

                if (currentLimit && currentLimit.amount && currentLimit.amount.amount !== amount ||
                    !currentLimit && defaultLimit !== amount) {
                    limits.push({
                        amount: amount,
                        timePeriod: timePeriod
                    });
                }
            }

            return limits;
        },

        errorUpdateLimits: function(response) {
            var data = response.data;
            var errorCode = data.errorCode;
            var message;

            message = i18n.tExt('playtech.mobile.ngresponsiblegaming.limits.error.' +
                (errorCode || 'default'), data.errorMessage);

            this.showInfo({
                content: message
            });

            core.trigger('page:refresh');
        },

        sendMessageSuccess: function(resp) {
            var data = resp.data || {};
            var status = data.status || {};
            var tk = status.code === 'OK'
                ? 'playtech.mobile.ngresponsiblegaming.questionnaire.questionnaireSuccessful'
                : 'playtech.mobile.ngresponsiblegaming.questionnaire.inboxError';

            window.Playtech.API.popup.closePopups('questionnaire');

            window.Playtech.API.popup.showPopup({
                id: 'questionnaire',
                title: this.translate('playtech.mobile.ngresponsiblegaming.questionnaire.policy'),
                content: i18n.t(tk)
            });
        },

        sendMessageFail: function() {
            window.Playtech.API.popup.closePopups('questionnaire');

            window.Playtech.API.popup.showPopup({
                id: 'questionnaire',
                title: this.translate('playtech.mobile.ngresponsiblegaming.questionnaire.policy'),
                content: i18n.t('playtech.mobile.ngresponsiblegaming.questionnaire.inboxError'),
                buttons: []
            });
        },

        showMessageInboxSubscribe: function() {
            this.showInfo({
                content: i18n.t('playtech.mobile.ngresponsiblegaming.questionnaire.inboxSubscribeFail')
            });
        }
    },
        {
            nameOfReplacers: ['LIMITS_QUESTIONNAIRE']
        });
});
